"use client";

import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import styles from "./styles.module.scss";
import Components from "@/components";
import utils from "@/utils";

const CourseWithAssignment = [
  "624c1b658fb34368cd250c4b",
  "619211b167c6840023573e8e",
  "61a4fa33ac5d0d0023d2a4f5",
  "624c6e058fb34368cd250c5d",
];

function Header(props) {
  const { isEnrolled, isRestricted, courseInfo, articleInfo } = useSelector(
    (state) => state.video
  );
  const user = useSelector((state) => state.user.users);

  const headerRef = useRef(null);

  const HeaderTabs = [
    {
      key: 0,
      isVisible: true,
      title: "About",
    },
    {
      key: 1,
      isVisible: true,
      title: "Next Video",
    },
    {
      key: 2,
      isVisible: !articleInfo,
      title: "Comments",
    },
    {
      key: 3,
      isVisible: !articleInfo && user?.email && isEnrolled,
      title: "Notes",
    },
    {
      key: 4,
      isVisible:
        !articleInfo &&
        user?.email &&
        isEnrolled &&
        (isRestricted || CourseWithAssignment.includes(courseInfo?._id)),
      title: "Assignments",
    },
  ];

  const scrollHeaderRight = () => {
    if (headerRef.current) {
      headerRef.current.scrollBy({
        left: 100,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <header className={styles["header"]} ref={headerRef}>
        {HeaderTabs.map((tab) => {
          if (tab.isVisible)
            return (
              <div
                id={`vd_TabMobile_${tab.title}`}
                key={tab.key}
                onClick={() => props.setActive(tab.title)}
                className={props.active === tab.title ? styles["active"] : ""}
              >
                <h3>{tab.title}</h3>
              </div>
            );
        })}
      </header>
    </>
  );
}

export default Header;
